import React, { useEffect, useState } from 'react';
import { MinusCircleOutlined, PlusOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Col, Divider, Form, Input, Row, Select, Space } from 'antd';
import accountService from '../../api/account.service';
import { ADD_MODE, SUCCESS_STATUS } from '../../utility/Constants';
import TextArea from 'antd/lib/input/TextArea';
import commonUtility from '../../utility/Utils';
const { Option } = Select;




const purchaseCardView = {
    background: "#fbfbfb",
    backgroundColor: "fbfbfb",
    padding: "7px 10px",
    paddingTop: "15px",
    borderRadius:'12px',
    boxShadow:'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    marginBottom:'10px',
    border:'1px solid #ddd'
   
  };

const TaxInvoiceDetailView = (props) => {


    const [descriptionList, setDescriptionList] = useState([]);
    const [accountList, setAccountList] = useState([]);
    const [cgstList, setCgstList] = useState([]);
    const [sgstList, setSgstList] = useState([]);
    const [igstList, setIgstList] = useState([]);



    useEffect(() => {
        accountService.accountListExceptCD().then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                //setAccountList(res.data.response_data);
                setDescriptionList(res.data.response_data);
            }

        });
    }, []);

    useEffect(() => {
        const data = {
            formdata: { gstType: "CGST", usedfor: "O" },
        };
        accountService.gstListByInputType(data).then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setCgstList(res.data.response_data);
            }
        });
    }, []);

    useEffect(() => {
        const data = {
            formdata: { gstType: "SGST", usedfor: "O" },
        };
        accountService.gstListByInputType(data).then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setSgstList(res.data.response_data);
            }
        });
    }, []);

    useEffect(() => {
        const data = {
            formdata: { gstType: "IGST", usedfor: "O" },
        };
        accountService.gstListByInputType(data).then((res) => {
            if (res.data.response_status === SUCCESS_STATUS) {
                setIgstList(res.data.response_data);
            }
        });
    }, []);


    useEffect(() => {
        
        if(props.form.getFieldValue('mode') == ADD_MODE){
            props.form.setFieldsValue({
                sale_detail: [
                    { 
                        cr_ac_id:'',
                        hsn:'',
                        unit:'',
                        qty:'',
                        rate_per_unit:'',
                        item_value:'',
                        discount:'',
                        taxable_amount:'',
                        cgst_id:'',
                        cgst_amount:'',
                        sgst_id:'',
                        sgst_amount:'',
                        igst_id:'',
                        igst_amount:'',
                        total_gst_amount:'',
                        net_amount:'',
                    }
                ],
            });
        }
        
      }, []);


    return (
        <>

            <h4 style={{ marginTop: '10px' }}>Tax Invoice Details</h4>
            {/* <Divider style={{margin:2}}/> */}
            <Form.List name="sale_detail" >
                {(fields, { add, remove }) => (
                    <>
                        {fields.map((field, index) => (

                        <div style={purchaseCardView} key={`salebilldetail-${index}`}>
                            <Row gutter={20} >

                            <Col xs={24} xl={6}>
                                    <Form.Item
                                        {...field}
                                        label="Description"
                                        name={[field.name, 'cr_ac_id']}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Item Required',
                                            },
                                        ]}
                                    >
                                     

                                     <Select className="text-left" 
                                       showSearch
                                       placeholder="Search to Select"
                                       optionFilterProp="children"
                                       filterOption={(input, option) =>
                                           // option.children.includes(input)
                                           option.children.toLowerCase().includes(input.toLowerCase())
                                       }
                                       filterSort={(optionA, optionB) =>
                                           optionA.children
                                               .toLowerCase()
                                               .localeCompare(optionB.children.toLowerCase())
                                       }
                                        placement="bottomLeft"
                                        allowClear={true}

                                        onSelect={(value, event) => props.onDecriptionChange(value,event,index)}

                                        >
                                            <Option >Select</Option>
                                            {descriptionList.length > 0
                                                ? descriptionList.map((desc_list) => (
                                                    <Option key={desc_list.account_master_id} value={desc_list.account_master_id} hsn={desc_list.hsn_code} >{desc_list.account_name}</Option>
                                                ))
                                                : ""}
                                        </Select>

                                        





                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={2}>
                                    <Form.Item
                                        {...field}
                                        label="HSN"
                                        name={[field.name, 'hsn']}
                                       
                                        
                                    >
                                        <Input readOnly={true} />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={2}>
                                    <Form.Item
                                        {...field}
                                        label="Unit"
                                        name={[field.name, 'unit']}
                                       
                                        
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={2}>
                                    <Form.Item
                                        {...field}
                                        label="Qty"
                                        name={[field.name, 'qty']}
                                       
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Required',
                                            },
                                        ]}
                                    >
                                        <Input onChange={(value, event) => props.calItemAmount(event,value,index )} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} xl={2}>
                                    <Form.Item
                                        {...field}
                                        label="Rate"
                                        name={[field.name, 'rate_per_unit']}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Required',
                                            },
                                        ]}
                                    >
                                        <Input onChange={(value, event) => props.calItemAmount(event,value,index )} />
                                    </Form.Item>
                                </Col>
                                <Col xs={24} xl={3}>
                                    <Form.Item
                                        {...field}
                                        label="Amount"
                                        name={[field.name, 'item_value']}

                                    >
                                        <Input readOnly={true} />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={3}>
                                    <Form.Item
                                        {...field}
                                        label="Discount"
                                        name={[field.name, 'discount']}

                                    >
                                        <Input onChange={(value, event) => props.calItemAmount(event,value,index )} />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={4}>
                                    <Form.Item
                                        {...field}
                                        label="Taxable"
                                        name={[field.name, 'taxable_amount']}

                                    >
                                        <Input readOnly={true} />
                                    </Form.Item>
                                </Col>


                                
                            </Row>
                            <Row gutter={20}>

                            <Col xs={24} xl={3}>
                                    <Form.Item
                                        {...field}
                                        name={[field.name, 'cgst_id']}
                                        label="CGST">
                                        <Select className="text-left" allowClear={false} 
                                        onSelect={(value, event) => props.onGSTChange(value,event,index)}
                                        >
                                            <Option key="0" value="" rate="0" type="CGST">Select</Option>
                                            {cgstList.length > 0
                                                ? cgstList.map((cgst_list) => (
                                                    <Option
                                                        key={cgst_list.id}
                                                        value={cgst_list.id}
                                                        rate={cgst_list.rate}
                                                        type="CGST"
                                                    >
                                                        {cgst_list.gstDescription}
                                                    </Option>
                                                ))
                                                : ""}
                                        </Select>
                                    </Form.Item>

                                    {/* <Form.Item
                                        {...field}
                                        label=""
                                        name={[field.name, 'cgst_rate']}
                                        hidden={false}

                                    >
                                        <Input readOnly={true} />
                                    </Form.Item> */}

                                </Col>

                                <Col xs={24} xl={2}>
                                    <Form.Item
                                        {...field}
                                        label="CGST Amt."
                                        name={[field.name, 'cgst_amount']}

                                    >
                                        <Input readOnly={true} />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={3}>
                                    <Form.Item
                                        {...field}
                                        name={[field.name, 'sgst_id']}
                                        label="SGST">
                                        <Select className="text-left" 
                                        onSelect={(value, event) => props.onGSTChange(value,event,index)}
                                        >
                                            <Option key="0" value="" rate="0" type="SGST">Select</Option>
                                            {sgstList.length > 0
                                                ? sgstList.map((sgst_list) => (
                                                    <Option
                                                        key={sgst_list.id}
                                                        value={sgst_list.id}
                                                        rate={sgst_list.rate}
                                                        type="SGST"
                                                    >
                                                        {sgst_list.gstDescription}
                                                    </Option>
                                                ))
                                                : ""}
                                        </Select>
                                    </Form.Item>

                                    {/* <Form.Item
                                        {...field}
                                        label=""
                                        name={[field.name, 'sgst_rate']}
                                        hidden={false}

                                    >
                                        <Input readOnly={true} />
                                    </Form.Item> */}

                                </Col>

                                <Col xs={24} xl={2}>
                                    <Form.Item
                                        {...field}
                                        label="SGST Amt."
                                        name={[field.name, 'sgst_amount']}

                                    >
                                        <Input readOnly={true} />
                                    </Form.Item>
                                </Col>


                                <Col xs={24} xl={3}>
                                    <Form.Item
                                        {...field}
                                        name={[field.name, 'igst_id']}
                                        label="IGST">
                                        <Select className="text-left" 
                                        onSelect={(value, event) => props.onGSTChange(value,event,index)}
                                        >
                                            <Option key="0" value="" rate="0" type="IGST">Select</Option>
                                            {igstList.length > 0
                                                ? igstList.map((igst_list) => (
                                                    <Option
                                                        key={igst_list.id}
                                                        value={igst_list.id}
                                                        rate={igst_list.rate}
                                                        type="IGST"
                                                    >
                                                        {igst_list.gstDescription}
                                                    </Option>
                                                ))
                                                : ""}
                                        </Select>
                                    </Form.Item>

                                    {/* <Form.Item
                                        {...field}
                                        label=""
                                        name={[field.name, 'igst_rate']}
                                        hidden={false}

                                    >
                                        <Input readOnly={true} />
                                    </Form.Item> */}

                                </Col>

                                <Col xs={24} xl={2}>
                                    <Form.Item
                                        {...field}
                                        label="IGST Amt."
                                        name={[field.name, 'igst_amount']}

                                    >
                                        <Input readOnly={true} />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={3}>
                                    <Form.Item
                                        {...field}
                                        label="Net GST"
                                        name={[field.name, 'total_gst_amount']}

                                    >
                                        <Input readOnly={true} />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={4}>
                                    <Form.Item
                                        {...field}
                                        label="Net Amount"
                                        name={[field.name, 'net_amount']}

                                    >
                                        <Input readOnly={true} />
                                    </Form.Item>
                                </Col>



                                <Col xs={24} xl={2}>


                                    <Form.Item
                                        {...field}
                                        label=" "
                                        name={[field.name, 'action']}

                                    >
                                        {/* <MinusCircleOutlined onClick={() => remove(field.name)} /> */}

                                        <Button
                                            type="danger"
                                            icon={<DeleteOutlined />}
                                            shape="circle"
                                            // onClick={() => remove(field.name)}
                                            onClick={() => props.removeDetail(index)}
                                        />
                                    </Form.Item>

                                </Col>

                                {/* <Col>
                                    <Form.Item
                                        {...field}
                                        label=" "
                                        name={[field.name, 'helper']}

                                    >
                                    <p>Note : Either you can select CGST,SGST or IGST</p>
                                    </Form.Item>
                                </Col> */}

                            </Row>

                            </div>

                        ))}

                        <Form.Item>
                            <Button shape='round' className='custom-button-green' onClick={() => add()}  icon={<PlusOutlined />}>
                                Add Tax Invoice Details
                            </Button>
                        </Form.Item>
                    </>
                )}
            </Form.List>
        </>



    );
};
export default TaxInvoiceDetailView;